"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../theme");
const common_styled_components_1 = require("../common-styled-components");
const NumberInput_1 = require("../generic/NumberInput");
const useParams_1 = require("../../hooks/useParams");
const react_select_1 = __importDefault(require("react-select"));
const PortSearchInput_1 = require("../generic/PortSearchInput");
const Panel = styled_components_1.default.div `
  width: 100%;
  margin-bottom: ${theme_1.theme.spacing(4)};
`;
const loadingOptions = [
    {
        value: false,
        label: "Laden",
    },
    {
        value: true,
        label: "Ballast",
    },
];
const findLoadingOption = (value) => loadingOptions.find((v) => v.value === value);
const seasonOptions = [
    {
        value: 1,
        label: "Winter",
    },
    {
        value: 2,
        label: "Spring",
    },
    {
        value: 3,
        label: "Summer",
    },
    {
        value: 4,
        label: "Autumn",
    },
];
const findSeasonOption = (value) => seasonOptions.find((v) => v.value === value);
exports.default = (props) => {
    const { title, initialParams, metadata, texts, setParams, hideIntroTexts } = props;
    const { localParams, setParamsHelper } = (0, useParams_1.useParams)({
        defaultParams: initialParams,
        setParams,
    });
    return ((0, jsx_runtime_1.jsxs)(Panel, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SmallSubtitle, { style: { marginBottom: theme_1.theme.spacing(1) }, children: title }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Grid, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: "IMO number" }), (0, jsx_runtime_1.jsx)(NumberInput_1.NumberInput, { value: localParams.imo_number, onChange: (value) => setParamsHelper({ imo_number: value }), allowEmpty: false })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: "Loading status" }), (0, jsx_runtime_1.jsx)(react_select_1.default, { options: loadingOptions, onChange: (newValue) => setParamsHelper({ ballast: newValue?.value }), value: localParams.ballast !== undefined
                                    ? findLoadingOption(localParams.ballast)
                                    : undefined, isOptionSelected: (option) => option.value === localParams.ballast })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: "Draft" }), (0, jsx_runtime_1.jsx)(NumberInput_1.NumberInput, { value: localParams.draft, onChange: (value) => setParamsHelper({ draft: value }), min: 1, isFloat: true, allowEmpty: false })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: "Speed (kn)" }), (0, jsx_runtime_1.jsx)(NumberInput_1.NumberInput, { value: localParams.speed, onChange: (value) => setParamsHelper({ speed: value }), min: 1, isFloat: true, allowEmpty: false })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: "Voyage season" }), (0, jsx_runtime_1.jsx)(react_select_1.default, { options: seasonOptions, onChange: (newValue) => setParamsHelper({ season: newValue?.value }), value: localParams.season !== undefined
                                    ? findSeasonOption(localParams.season)
                                    : undefined, isOptionSelected: (option) => option.value === localParams.season })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: "Departure port" }), (0, jsx_runtime_1.jsx)(PortSearchInput_1.PortSearchInput, { value: {
                                    value: localParams.departure_port ?? "",
                                    label: localParams.departure_port_label ?? "",
                                }, onChange: (value, name) => setParamsHelper({
                                    departure_port: value,
                                    departure_port_label: name,
                                }) })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: "Destination port" }), (0, jsx_runtime_1.jsx)(PortSearchInput_1.PortSearchInput, { value: {
                                    value: localParams.destination_port ?? "",
                                    label: localParams.destination_port_label ?? "",
                                }, onChange: (value, name) => setParamsHelper({
                                    destination_port: value,
                                    destination_port_label: name,
                                }) })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: texts.emission_allowance_price }), (0, jsx_runtime_1.jsx)(NumberInput_1.NumberInput, { value: localParams.emission_allowance_price, onChange: (value) => setParamsHelper({ emission_allowance_price: value }), allowEmpty: false })] })] })] }));
};
